import { Button } from '@televet/kibble-ui/build/components/Button';
import { Heading } from '@televet/kibble-ui/build/components/Heading';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Box } from '@televet/kibble-ui/build/chakra';
import React from 'react';
import { CustomSnoozeModal } from 'shared/components/CustomSnoozeModal';
import { SnoozedInfoComponent } from 'shared/components/Layouts/DefaultAuthenticated/components/SnoozePopover';
import { useSnoozeProvider } from 'shared/providers/SnoozeProvider';
import { MenuTitle } from '.';
import MobileMenuItem from './MobileMenuItem';
import { useMobileMenuProvider, MobileMenuViews } from './MobileMenuProvider';

const SnoozeNotificationsView = (): JSX.Element => {
  const { setCurrentMobileMenuView } = useMobileMenuProvider();
  const {
    isSnoozed,
    snoozedUntil,
    handleTimeClick,
    handleTomorrowClick,
    turnOffSnooze,
    isCustomSnoozeModalOpen,
    onCustomSnoozeModalOpen,
    onCustomSnoozeModalClose,
  } = useSnoozeProvider();

  return (
    <div>
      <CustomSnoozeModal isOpen={isCustomSnoozeModalOpen} onClose={onCustomSnoozeModalClose} />
      <MenuTitle>
        <Button
          iconName="chevronLeft"
          variant="ghostNeutral"
          onClick={(): void => setCurrentMobileMenuView(MobileMenuViews.Root)}
        />
        <Heading>{MobileMenuViews.SnoozeNotifications}</Heading>
      </MenuTitle>
      <Box p={4}>
        <Text size="lg" fontWeight="bold" m="12px 20px">
          Do not disturb for...
        </Text>
      </Box>
      {snoozedUntil && isSnoozed && <SnoozedInfoComponent />}
      <MobileMenuItem hasIcon={false} onClick={(): void => handleTimeClick(30)} text="30 Minutes" />
      <MobileMenuItem hasIcon={false} onClick={(): void => handleTimeClick(60)} text="1 Hour" />
      <MobileMenuItem hasIcon={false} onClick={handleTomorrowClick} text="Tomorrow at 8 am" />
      <MobileMenuItem onClick={onCustomSnoozeModalOpen} text="Custom" />
      {isSnoozed && <MobileMenuItem onClick={turnOffSnooze} text="Turn off snooze" />}
    </div>
  );
};

export default SnoozeNotificationsView;
